import { IMenuItem } from '../../MenuItem/MenuItem.types'

export enum McmMenuIds {
  MCM = 'mcm',
  REPORTS = 'mcm-reports',
  MCM_SETTINGS = 'mcm-settings',
  SETTINGS = 'settings',
  API = 'mcm-api',
  EMAILS = 'mcm-emails',
  LEGACY = 'mcm-legacy',
  ADMIN = 'mcm-admin',
}

export interface McmMenuItemsVisibility {
  menuItems: IMenuItem[]
  visibility: { [key: string]: boolean }
}
